import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StripeService } from 'ngx-stripe';
import { delay, map, switchMap, tap } from 'rxjs/operators';
import { FinishPaymentRequest } from 'src/app/api/models';
import { UserStripePaymentsApiService, UserProfileApiService, UserBookingsApiService, UserTowerGroupsApiService } from 'src/app/api/services';
import { StorageService } from 'src/app/core/services/storage.service';
import { StorageEnums } from 'src/shared/models/enums';
import { PaymentSlides, CustomerPaymentMethod, PaymentInfo, PaymentStorageData, PaymentObject, PaymentMethodEnum } from 'src/shared/models/payment.model';
import { BookingHelperService } from 'src/shared/services/helpers/booking-helper.service';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { EventsService } from 'src/shared/services/helpers/events.service';
import { PaymentsHelperService } from 'src/shared/services/helpers/payments-helper.service';
import { MspApiService } from 'src/shared/services/msp-api.service';
import { AddNewCreditCardComponent } from '../../components/add-new-credit-card/add-new-credit-card.component';
import { PayWithCreditCardComponent } from '../../components/pay-with-wrapper/components/pay-with-credit-card/pay-with-credit-card.component';
import { PaymentSuccessfulComponent } from '../../components/payment-successfull/payment-successful.component';
import { ChooseFreeHoursComponent } from "../../components/choose-free-hours/choose-free-hours.component";
import { Swiper, SwiperOptions } from 'swiper/types';
import { IonContent } from '@ionic/angular/standalone';
import { NgIf } from '@angular/common';

@Component({
  selector: 'vl-payment',
  templateUrl: './payment.page.html',
  styleUrls: ['./payment.page.scss'],
  standalone: true,
  imports: [IonContent, PaymentSuccessfulComponent, NgIf, ChooseFreeHoursComponent]
})

export class PaymentPage implements OnInit, AfterViewInit {
  @Input() fromBuySubscription: boolean = false;
  @ViewChild(AddNewCreditCardComponent, { static: true }) newCardComp: AddNewCreditCardComponent;
  @ViewChild(PayWithCreditCardComponent, { static: true }) payWithComp: PayWithCreditCardComponent;
  @ViewChild(PaymentSuccessfulComponent) paymentSuccessfulComponent: PaymentSuccessfulComponent;
  @ViewChild('swiperContainer') swiperEl: ElementRef<HTMLElement>;
  @ViewChild(IonContent, { read: ElementRef, static: true }) ionContentEl: ElementRef;

  slidedEnum = PaymentSlides;
  currentSlide: PaymentSlides;
  creditCards: Array<CustomerPaymentMethod> = [];
  inited = true;
  paymentInfo: PaymentInfo;
  showCardList = false;
  swiper: Swiper;

  slideOpts: SwiperOptions = {
    speed: 200,
    initialSlide: 0,
    allowTouchMove: false
  };

  paymentType: { type: 'new-card' | 'saved-card'; card: CustomerPaymentMethod; returnSlide?: number };

	constructor(
		private activatedRoute: ActivatedRoute,
		private UserPaymentsApiService: UserStripePaymentsApiService,
		private spinner: CustomSpinnerService,
		private cd: ChangeDetectorRef,
		private profileService: UserProfileApiService,
		private paymentsHelper: PaymentsHelperService,
		private bookingService: UserBookingsApiService,
		private eventsService: EventsService,
		private bookingHelper: BookingHelperService,
		private groupsApiService: UserTowerGroupsApiService,
		private stripePaymentService: UserStripePaymentsApiService,
		private storageService: StorageService,
		private stripeService: StripeService,
		private mspApiService: MspApiService
	) {}

	ngOnInit(): void {
		if (this.paymentsHelper.paymentData) {
		this.paymentInfo = this.paymentsHelper.paymentData;
		}
	}

	ngAfterViewInit(): void {
		this.activatedRoute.queryParams.subscribe(async r => {
		if (r.redirect_status) {
			await this.spinner.show();
			this.handleGiroPay(r);
		} else {
			this.getCards();
		}
		});
	}

	ionViewDidEnter() {
		const dataForAnalytic = { ...this.paymentInfo };
		dataForAnalytic.booking = null;
	}

	ionViewWillLeave() {
	}

	private getToken() {
		this.UserPaymentsApiService.getStripePublicKey()
			.pipe(delay(300))
			.subscribe(res => {
				if (!this.stripeService.stripe) {
					this.stripeService.setKey(res.value);
				}
				setTimeout(() => {
					this.paymentsHelper.setStripeReady(res.value);
				}, 100)
			})
	}

	private getCards() {
		this.spinner.show().then(() => {
			this.UserPaymentsApiService.getCustomerPaymentMethods()
				.pipe(
					map(r => {
						return r.map(card => {
							return {
								...card,
								...{
									brandImg: this.paymentsHelper.getCardBrandsImage(card.brand),
									type: PaymentMethodEnum.STRIPE_CARD
								}
							}
						}).filter(card => this.isPaymentMethodSupported(card.type));
					}),
					switchMap(r => {
						this.creditCards = r;
						return this.addPayPalAndGiropay()
					})
				)
				.subscribe(() => {
					this.inited = true;
					this.cd.detectChanges();
					this.slideTo(PaymentSlides.FreeHours);
				}, error => {
					this.inited = true;
					console.log('error', error);
					this.slideTo(PaymentSlides.FreeHours);
					this.spinner.hide().then(() => {
						this.getToken();
					});
				})
		})
	}

	addNewCard() {
		this.paymentType = {
			type: 'new-card',
			card: {
				type: PaymentMethodEnum.STRIPE_CARD
			}
		}

		this.slideTo(PaymentSlides.ChooseNewPaymentMethods);
	}

	chooseCard(info: any) {
		let card: CustomerPaymentMethod = info.card;
		if (info.type === 'select') {
			this.paymentType = {
				card: card,
				returnSlide: this.slidedEnum.ExistsPaymentMethods,
				type: 'saved-card'
			}
		} else {
			this.paymentType = {
				card: card,
				returnSlide: this.slidedEnum.ChooseNewPaymentMethods,
				type: 'new-card'
			}
		}
		this.slideTo(PaymentSlides.AddNewCard);
	}

	public onSuccess() {
		this.slideTo(PaymentSlides.PaymentStatus);
		setTimeout(() => {
			this.paymentSuccessfulComponent.setState(true);
			this.cd.detectChanges();
		}, 25)
	}

	public onError() {
		this.paymentSuccessfulComponent.setState(false);
		this.slideTo(PaymentSlides.PaymentStatus);
	}

	slideTo(to: PaymentSlides) {
		this.currentSlide = to;
        this.swiper?.slideTo(to);
        this.cd.detectChanges();
	}

	addPayPalAndGiropay() {
		return this.profileService.getUserProfile()
			.pipe(
				tap(p => {
					if (this.isPaymentMethodSupported(PaymentMethodEnum.PAYPAL)) {
						this.creditCards.push(this.paymentsHelper.createMethod(PaymentMethodEnum.PAYPAL, p.paypalFullName));
						this.showCardList = true;
						this.cd.detectChanges();

						this.spinner.hide().then(() => {
							this.getToken();
						});
					} else {
						this.showCardList = true;
						this.cd.detectChanges();
						this.spinner.hide().then(() => {
							this.getToken();
						});
					}
			
					if (this.isPaymentMethodSupported(PaymentMethodEnum.PAYREXX_TWINT)) {
						this.creditCards.push(this.paymentsHelper.createMethod(PaymentMethodEnum.PAYREXX_TWINT));
					}
				})
			);
	}

	handleGiroPay(params) {
		const {
			redirect_status
		} = params;
		if (redirect_status === 'succeeded') {
			console.log('handleGiroPay');
			this.inited = true;
			this.handlePaymentSuccess();
			this.spinner.hide();
		} else if (redirect_status === 'failed') {
			this.inited = true;
			this.spinner.show().then(async () => {
				this.onError();
				await this.spinner.hide();
			});
		}
	}


	private async handlePaymentSuccess() {
		let storageData: PaymentStorageData = await this.storageService.getItem(StorageEnums.PAYMENT_DATA);
		this.paymentInfo.bookingId = storageData.id;
		this.paymentInfo.groupId = storageData.id;
		this.paymentInfo.purchase = {
			id: storageData.id
		}
		this.paymentInfo.type = storageData.type as any;

		let paymentId = storageData.paymentIds.main;
		let body: FinishPaymentRequest = {
			paymentId: paymentId
		};

		if (storageData.paymentIds.freeHours) {
			body = {
				...body,
				...{ freeHoursPaymentId: storageData.paymentIds.freeHours }
			}
		}

		this.stripePaymentService.finishPayment({
			body: body
		}).subscribe(async () => {
			await this.storageService.removeItem(StorageEnums.PAYMENT_DATA);
			this.analyticsCompletePayment();
			switch (this.paymentInfo.type) {
				case PaymentObject.PayPerUse:
					this.terminateBooking();
					break;
				case PaymentObject.Booking:
					this.terminateBooking();
					break;
				case PaymentObject.Subscription:
					await this.createSubscription(paymentId);
					break;
				case PaymentObject.Purchase:
					this.finishPurchase();
					break;
			}
		});
	}

	private isPaymentMethodSupported(method: PaymentMethodEnum): boolean {
		return this.paymentsHelper.isPaymentMethodSupported(method);
	}

	private analyticsCompletePayment() {
		const dataForAnalytics = { ...this.paymentInfo };
		dataForAnalytics.method = PaymentMethodEnum.STRIPE_GIROPAY;
	}

	private terminateBooking() {
		let bookingId = Number(this.paymentInfo.bookingId);
		this.bookingService.terminateBooking({
			bookingId: bookingId,
		}).subscribe(() => {
			this.eventsService.refreshBookings();
			this.bookingHelper.handleTerminateBooking(bookingId);
			this.onSuccess();
			this.spinner.hide();
		});
	}

	async createSubscription(paymentId) {
		const subStart = await this.storageService.getItem(StorageEnums.SUB_START_DATE);
		let $subscribeSubsciption = this.groupsApiService.subscribe({
			id: this.paymentInfo.groupId,
			body: {
				paymentId,
				startDate: new Date(this.paymentInfo.subscriptionStartDate || subStart).toISOString()
			}
		});

		const handleResp = (s) => {
			this.eventsService.refreshBookings();
			this.eventsService.updateSubs();
			this.onSuccess();
			this.spinner.hide();
		}

		$subscribeSubsciption.subscribe((s) => {
			handleResp(s)
		})
	}

	finishPurchase() {
		this.mspApiService.pingPayment(this.paymentInfo.purchase.id).subscribe(async () => {
			this.onSuccess();
			this.spinner.hide();
		}, error => {
			this.onError();
			this.spinner.hide();
		})
	}

}
